import React, { useState, useEffect } from "react";
import reportAPI from "../../../../api/report";
import { FilterYearMonthType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import { BARCHART, FLEXDROPDOWN, STYLEBODY } from "../../../../utils/useStyle";
import { ExcelInfectionAt } from "../../functions/Report.ExportInfectionAt";
import { formatInfectionAt } from "../../utils/Report.Format";

const ReportAttemptInfection = ({ userDept }) => {
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [month, setMonth] = useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [type, setType] = useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = useState({
    complications_pneumothorax: 0,
    complications_hemothorax: 0,
    complications_arterial_puncture: 0,
    complications_paresthesia: 0,
    complications_nerve_injury: 0,
    complications_limb_ischemia_related_to_arterial_puncture: 0,
    complications_wire: 0,
    other_complications: 0,
    total: 0,
  });

  useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getInfectionAttemptReport({
          year: String(year?.value),
          type: String(type?.value),
          month: String(month?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching infection attempt report:", error);
      }
    };
    fetchData();
  }, [year, type, month, userDept]);

  const listTable = [
    { name: "Pneumothorax", count: data?.complications_pneumothorax },
    { name: "Hemothorax", count: data?.complications_hemothorax },
    { name: "Arterial puncture", count: data?.complications_arterial_puncture },
    { name: "Paresthesia", count: data?.complications_paresthesia },
    { name: "Nerve injury", count: data?.complications_nerve_injury },
    { name: "Wire complication", count: data?.complications_wire },
    { name: "Other", count: data?.other_complications },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const count = payload?.[0]?.value || 0;
      const percentage = ((count * 100) / data.total).toFixed(1);

      return (
        <div className="bg-gray-50 text-gray-700 text-sm px-2 py-1 rounded">
          <p className="label">{`count : ${count} (${percentage}%)`}</p>
        </div>
      );
    }

    return null;
  };

  const renderCustomLabel = (props) => {
    const { x, y, width, height, value } = props;
    const percentage = ((value / data?.total) * 100).toFixed(1) + "%";
    const insideBarPosition = y + height / 2;

    return (
      <g>
        <text
          x={x + width / 2}
          y={insideBarPosition}
          fill="#111827"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {`${value} (${percentage})`}
        </text>
      </g>
    );
  };

  return (
    <div>
      <div className={``}>
        <div className="my-10">
          <>
            <div className="flex flex-col gap-4">
              <div className="text-black text-lg font-medium">
                การเกิดภาวะแทรกซ้อนระหว่างทำหัตถการ
                <div className={STYLEBODY}>
                  แยก pneumothorax, hemothorax, limb ischemia related to
                  arterial puncture, nerve injury ของปี "{year.label}" ประเภทสาย
                  "{type.label}"
                </div>
              </div>
              <div className={FLEXDROPDOWN}>
                <FilterYearMonthType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                  month={month}
                  setMonth={setMonth}
                />
                <ButtonExcel
                  onClick={() => {
                    ExcelInfectionAt(
                      formatInfectionAt(data),
                      year,
                      type,
                      setLoading
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div>จำนวนสายทั้งหมด {data?.total}</div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Bar label={renderCustomLabel} dataKey="count" fill="#CC9933" />
              </BarChart>
            </div>
            <div className="grid grid-cols-7 mx-16 my-8 text-sm">
              <div className=" -rotate-45 transform-gpu text-center">
                Pneumothorax
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Hemothorax
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Arterial puncture
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Paresthesia
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Nerve injury
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Wire complication
              </div>
              <div className=" -rotate-45 transform-gpu text-center">Other</div>
            </div>
            <div className="flex justify-center">
              <div className="flex items-center">
                <div className="box-content h-3 w-4 bg-yellowgraph"></div>
                <div className="text-yellowgraph mx-2">count</div>
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportAttemptInfection;
